var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.CharacterStateEnum = {
  IDLE: 0,
  FLY: 1,
  FALL: 2,
};

EHDI.game.Character = function () {
    EHDI.aka.Container.call(this);
  };

EHDI.game.Character.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Character.prototype.init = function () {
  this._characterStartingX = 230;
  this._characterStartingY = 200;

  this._baseSpeed = 0.2;
  this._currentSpeed;

  this._jumpVelY = -14;
  this._currentVelY;
  this._gravity = 0.8;

  this._animation;
  this._collided = false;

  this.tl1;
  this.tl2;

  this._timer;

  this._currentState = EHDI.game.CharacterStateEnum.IDLE;

  this._hitbox;

  if (this._hitbox == undefined) {
    this._hitbox = new EHDI.game.Hitbox(40, 40, 40, 0, 0x0000ff);

    this.addChild(this._hitbox);
  }

  if (this._animation == undefined) {
    this._animation = new EHDI.game.Animation();
    this._animation.init('dove_anim');
    
    this.addChild(this._animation.getDisplay());
  }

  if (this._timer == undefined) {
    this._timer = new EHDI.util.Time();
  }

  this.x = this._characterStartingX;
  this.y = this._characterStartingY;
  this.rotation = 0;
};

EHDI.game.Character.prototype.stopAnimation = function () {
  this._animation.stop();
}

EHDI.game.Character.prototype.collided = function () {
  this._collided = true;

  this._animation.changeAnimation2('dove_hit');
  this._animation.play();

  this.tl1 = gsap.to(this, 1, {x:this.x - 100});
  this.tl2 = gsap.to(this, 1, {y:this.y - 20, ease:Back.easeOut,
    onComplete:this.collidedAnimationCompleted.bind(this)});
};

EHDI.game.Character.prototype.collidedAnimationCompleted = function () {
  this.emit('ANIMATION_COMPLETED');
  
};

EHDI.game.Character.prototype.reset = function () {
  if (this.tl1 != null) {
    this.tl1.kill();
    this.tl1 = null;
  }

  if (this.tl2 != null) {
    this.tl2.kill();
    this.tl2 = null;
  }

  if (this.tl3 != null) {
    this.tl3.kill();
    this.tl3 = null;
  }

  
}

EHDI.game.Character.prototype.isCollided = function () {
  return this._collided;
};

EHDI.game.Character.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Character.prototype.stateManager = function (newState) {
  if (this.currentState != newState) {
    this._currentState = newState;
  }
};

EHDI.game.Character.prototype.start = function () {
  this._currentSpeed = this._baseSpeed;
  this._currentVelY = 0;

  this.stateManager(EHDI.game.CharacterStateEnum.FALL);

  this._animation.changeAnimation('fly');
  this._animation.play();
};

EHDI.game.Character.prototype.fly = function () {
  if (this._timer.getTimeInSeconds() >= 1) {
    EHDI.GAME.soundManager.playSFX("wing_flap");
    this._timer.reset();
  }

  this._currentVelY = this._jumpVelY;

  this.stateManager(EHDI.game.CharacterStateEnum.FLY);
};

EHDI.game.Character.prototype.fall = function () {
  this.stateManager(EHDI.game.CharacterStateEnum.FALL);
};

EHDI.game.Character.prototype.getSpeed = function () {
  return this._currentSpeed;
};

EHDI.game.Character.prototype.updateSpeed = function (level) {
  if (this.tl3 != null) {
    this.tl3.kill();
    this.tl3 = null;
  }

  var newSpeed;

  if (level == 1) {
    newSpeed = this._baseSpeed;
  } else if (level == 2) {
    newSpeed = this._baseSpeed * 1.3;
  } else if (level == 3) {
    newSpeed = this._baseSpeed * 1.8;
  } else if (level == 4) {
    newSpeed = this._baseSpeed * 2.2;
  } else if (level == 5) {
    newSpeed = this._baseSpeed * 2.6;
  } else if (level == 6) {
    newSpeed = this._baseSpeed * 3;
  } else {
    newSpeed = 0;
  }

  this.tl3 = gsap.to(this, 0.5, {_currentSpeed:newSpeed, ease:Sine.easeIn});
}

EHDI.game.Character.prototype.update = function (delta) {
  if (!this._collided) {
    if (this.y < 450)
      this._currentVelY += this._gravity;
    else if (this._currentVelY > 0)
      this._currentVelY *= 0.6;

    if (this._currentState == EHDI.game.CharacterStateEnum.FLY &&
    this._currentVelY > 0) {
      this.fall();
    }

    if (this._currentVelY > 40)
      this._currentVelY = 40;

    if (this.y < 100 && this._currentVelY < 0)
      this._currentVelY = 0;
    else if (this.y < 140 && this._currentVelY < 0)
      this._currentVelY = this._currentVelY * 0.2;
    else if (this.y < 160 && this._currentVelY < 0)
      this._currentVelY = this._currentVelY * 0.5;

    this.y += this._currentVelY;

    this._hitbox.update(this.x, this.y);
  }
};

EHDI.game.Character.prototype.getCharacterState = function () {
  return this._currentState;
};
